import { BackupRestoreIcon } from './BackupRestoreIcon';

/**
 * author: Google
 * id 36F8C2B4-C82C-4546-AFFC-601ECA54A603
 * name backup-restore
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/backup-restore.svg
 * tags
 */
export const SettingsBackupRestoreIcon = BackupRestoreIcon;
export default SettingsBackupRestoreIcon